import React, { useState } from "react";
import { BookOpen, X } from "lucide-react";

import angel from "../img/perfil/angel_josue.jpeg";
import alex from "../img/perfil/alex_geovanny.jpeg";
import jose_andres from "../img/perfil/jose_andres.jpeg";

const ponentesData = [
  {
    id: 1,
    nombre: "Ángel Josué Hernández Cazco",
    carrera: "Derecho",
    contenido:
      "Ha demostrado una destacada trayectoria académica, manteniendo un rendimiento de excelencia durante su formación. Se caracteriza por su perseverancia, liderazgo, compromiso con el aprendizaje y vocación de servicio.",
    sintesis: (
      <>
        <p>
          Ángel, de 22 años, cursa el último ciclo de la carrera de Derecho y
          ha construido una destacada trayectoria académica, reflejada en un
          promedio de excelencia. A pesar de su discapacidad visual, se
          distingue por su perseverancia, liderazgo y vocación de servicio,
          apoyando constantemente a sus compañeros y participando activamente en
          cursos y conversatorios.
        </p>

        <p className="mt-4">
          En este camino, el respaldo de su familia ha sido fundamental: su
          madre lo acompaña diariamente durante su formación y su padre, con
          esfuerzo y dedicación, hace posible que continúe sus estudios y
          tratamientos. Juntos han demostrado que el amor, el compromiso y la
          resiliencia son la base para transformar los desafíos en
          oportunidades y alcanzar grandes metas.
        </p>
      </>
    ),
    foto: angel,
  },

  {
    id: 2,
    nombre: "Alex Geovanny Peña Abad",
    carrera: "Educación Básica",
    contenido:
      "Ha demostrado una destacada capacidad de adaptación, perseverancia y compromiso con su formación académica, afrontando nuevos desafíos con determinación y manteniendo un firme enfoque en su desarrollo personal y profesional.",
    sintesis: (
      <>
        <p>
          Alex, de 47 años, es estudiante de la carrera de Educación Básica en
          modalidad a distancia. Tras adquirir una discapacidad visual a causa
          de la diabetes, decidió asumir el desafío de reinventarse: aprendió
          braille, el uso de lectores de pantalla e inició su formación
          universitaria.
        </p>

        <p className="mt-4">
          Además, practica goalball, deporte paralímpico para personas con
          discapacidad visual, demostrando que los límites pueden
          transformarse en nuevas oportunidades. El apoyo incondicional de su
          esposa ha sido fundamental para continuar construyendo su proyecto de
          vida.
        </p>
      </>
    ),
    foto: alex,
  },

  {
    id: 3,
    nombre: "José Andrés Puglla Suqui",
    carrera: "Logística y Transporte",
    contenido:
      " Decidió continuar con su formación académica, motivado por el apoyo de su familia y por su firme compromiso con su crecimiento personal y profesional, demostrando constancia, dedicación y una actitud resiliente frente a los retos.",
    sintesis: (
      <>
        <p>
          José Andrés superó un grave accidente que le ocasionó una
          discapacidad física. Aceptó su realidad con madurez, adaptándose a
          las dificultades para hablar y caminar sin rendirse frente a los
          comentarios negativos.
        </p>

        <p className="mt-4">
          Gracias al apoyo de su fe, su familia y la UTPL, continúa avanzando
          en sus estudios. Hoy su historia inspira a otros a superar barreras y
          demuestra que los límites no los define la condición, sino la
          actitud.
        </p>
      </>
    ),
    foto: jose_andres,
  },
];

export default function SerMas() {
  const [historiaActiva, setHistoriaActiva] = useState(null);

  return (
    <>
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Encabezado */}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-flex items-center rounded-full bg-amber-100 px-4 py-1 text-sm font-semibold text-[#004270] mb-5">
              Historias que inspiran
            </span>

            <h2>Ser más</h2>

            <p className="mt-4">
              Historias de vida que inspiran, rompen barreras y demuestran que
              el talento no tiene límites.
            </p>
          </div>

          {/* Tarjetas */}
          <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
            {ponentesData.map((ponente) => (
              <article
                key={ponente.id}
                className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-lg transition duration-300 hover:-translate-y-2 hover:shadow-2xl flex flex-col"
              >
                {/* Imagen */}
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={ponente.foto}
                    alt={ponente.nombre}
                    className="h-full w-full object-cover object-top transition duration-500 hover:scale-105"
                  />
                </div>

                {/* Contenido */}
                <div className="flex flex-1 flex-col p-7">
                  <span className="inline-flex self-start rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-[#004270]">
                    {ponente.carrera}
                  </span>

                  <h3 className="mt-4 text-xl font-bold">
                    {ponente.nombre}
                  </h3>

                  <p className="mt-4 flex-1 text-slate-600 leading-relaxed">
                    {ponente.contenido}
                  </p>

                  <button
                    onClick={() => setHistoriaActiva(ponente)}
                    className="mt-8 inline-flex items-center justify-center gap-2 rounded-xl bg-[#004270] px-5 py-3 font-medium text-white transition hover:bg-[#00365d]"
                  >
                    <BookOpen size={18} />
                    Conocer historia
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {historiaActiva && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
          <div className="relative w-full max-w-5xl overflow-hidden rounded-3xl bg-white shadow-2xl">

            {/* Botón cerrar */}
            <button
              onClick={() => setHistoriaActiva(null)}
              className="absolute right-5 top-5 z-20 rounded-full bg-white p-2 shadow hover:bg-slate-100"
            >
              <X size={22} />
            </button>

            <div className="grid md:grid-cols-[340px_1fr]">

              {/* Imagen */}
              <div className="h-full">
                <img
                  src={historiaActiva.foto}
                  alt={historiaActiva.nombre}
                  className="h-full w-full object-cover object-top"
                />
              </div>

              {/* Información */}
              <div className="max-h-[85vh] overflow-y-auto p-10">

                <span className="inline-flex rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-[#004270]">
                  {historiaActiva.carrera}
                </span>

                <h2 className="mt-5">
                  {historiaActiva.nombre}
                </h2>

                <div className="mt-8 space-y-5 leading-8 text-slate-700">
                  {historiaActiva.sintesis}
                </div>

              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}